"use client";

import { COOKIES } from ".constants/cookies";
import { usePortalContext } from "@cloai/uikit";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { FC } from "react";
import { useCookies } from "react-cookie";

import { cn } from "@/utils/cn";

import { LOGO_ITEMS } from "../const";
import { AutoSlider } from "../ui/AutoSlider";

type LogosAutoSlideProps = {
  className?: string;
};

export const LogosAutoSlide: FC<LogosAutoSlideProps> = ({ className }) => {
  const t = useTranslations("ClothoffLanding");
  const { currentPortal } = usePortalContext();
  const [cookies] = useCookies([COOKIES.RULES_ACCEPTED]);

  const isActive = +cookies.rulesAccepted === 1 && !currentPortal;

  return (
    <AutoSlider className={className} isPause={!isActive}>
      {LOGO_ITEMS.slice(0, 3).map((logo, index) => (
        <Image
          key={index}
          src={logo}
          alt=""
          priority
          className={cn(
            "h-8 w-auto max-w-32 shrink-0 grow-0 basis-auto transform-gpu object-contain pl-6",
            "md:h-12 md:max-w-60 md:pl-10",
          )}
        />
      ))}
      <p className={cn("pl-6 text-3xl font-bold text-neutral-400", "md:pl-10")}>
        {t("theyWroteAboutUs")}
      </p>
      {LOGO_ITEMS.slice(3).map((logo, index) => (
        <Image
          key={index}
          src={logo}
          alt=""
          priority
          className={cn(
            "h-8 w-auto max-w-32 shrink-0 grow-0 basis-auto transform-gpu object-contain pl-6",
            "md:h-12 md:max-w-60 md:pl-10",
          )}
        />
      ))}
    </AutoSlider>
  );
};
